export { FaroProfiler } from './FaroProfiler';
export { withFaroProfiler } from './withFaroProfiler';
//# sourceMappingURL=index.js.map